<template>
  <div>
    <toggle-collapse>
      <b-card style="position: relative" :title="$t('Filter Plans')">
        <b-row class="mt-2">
          <b-col sm="12" md="6">
            <b-form-group :label="$t('Owners')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.owners"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[...owners]" :reduce="d => d.id"
                v-on:input="reFilterPlans('owners', Object.assign(request)), refilterContractByOwner(request.owners)" />
              <small v-if="errors && ('owners' in errors)" class="text-danger">
                {{ $t(errors['owners'][0]) }}
              </small>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group :label="$t('contracts')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.contracts"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[...contracts]" :reduce="d => d.id" />
              <small v-if="errors && ('contracts' in errors)" class="text-danger">
                {{ $t(errors['contracts'][0]) }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

    </toggle-collapse>

    <!-- form report -->
    <b-card style="position: relative" >
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <b-form @submit.prevent="getReport" class="">
        <b-row class="mt-2">
          <b-col v-if="report_type == 'report'" md="6" sm="6">
            <!-- report range date -->
            <b-form-group :label="$t('Select Date')" label-for="report-date" :state="null">
              <flat-pickr :state="null" class="form-control" :config="{ ...pickerOptions }" :value="request.date"
                placeholder=" new Date()" />

              <b-form-invalid-feedback v-if="errors && ('date' in errors)"
                :state="errors && ('date' in errors) ? false : null">
                {{ errors['date'][0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col  md="6" sm="6">
              <b-form-group
          :label="$t('Min Stop Time In minutes')"
          label-for="basicInput"
        >
          <b-form-input
            id="basicInput"
            v-model="request.minStopTime"
            placeholder="0"
                     
          />
          <b-form-invalid-feedback v-if="errors && ('minStopTime' in errors)"
                :state="errors && ('minStopTime' in errors) ? false : null">
                {{ errors.minStopTime[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
       
            </b-col>
        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col v-if="report_type == 'report'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

          <b-col v-if="report_type == 'setting'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
              @click="saveDialySetting('garden')">
              {{ $t('Save Setings') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields" :value="request.date"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="dataTableloading||loading"
        :getReport="getReport" :total="total" :from="from" :to="to"  :sortData="sortData" />

    </div>



  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, VBTooltip,
  BInputGroupAppend,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted } from '@vue/composition-api'
import reportLogic from '@/app/reports/containerPestPlanSummaryReport/logic'

import reportForm from '@/app/reports/containerPestPlanSummaryReport/reportForm'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import DataTable from '@/views/reports/data-table/DataTable.vue'

import { ReportSetting } from '@/views/reports/ReportSettings'


export default {
  components: {
    BRow,
    BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert,
    BFormGroup,
    BFormInput, flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner, BInputGroupAppend,
    ToggleCollapse,
    DataTable
  },
  directives: {
    Ripple, 'b-tooltip': VBTooltip,
  },
  props: {
    report_type: {
      type: String,
      default: 'report'

    }
  },

  setup(props, { root }) {


    const tableRef = ref(null)

    const { owners, contracts, contracts_orig } = reportForm()
    const { report_data, request, errors, loading, getReport, from, to, total, isSortDirDesc, sortBy, dataTableloading} = reportLogic()

    const sortData = (data)=> {
      sortBy.value = data.sortBy
      isSortDirDesc.value = data.isSortDirDesc
    }

    const filter_included_fields = ['id', 'workShift', 'totalDevices', 'workingDevices', 'totalDistance', 'absentDevices', 'percent']
    const  pickerOptions = {
        dateFormat: 'Y-m-d',
        mode: 'single',
        onClose: function(selectedDates, dateStr, instance) {
          request.value.date = dateStr
        }
      }

    const report_fields = [
      {
        key: 'index',
        label: 'id',
      },
      {
        key: 'workShift',
        label: 'work shift',
        sortable: true
      },
      {
        key: 'totalDevices',
        label: 'total devices',
        sortable: true
      },
      {
        key: 'workingDevices',
        label: 'working devices',
        sortable: true
      },
      {
        key: 'totalDistance',
        label: 'total distance',
        sortable: true
      },
      {
        key: 'absentDevices',
        label: 'absent devices',
        sortable: true
      },
      {
        key: 'percent',
        label: 'percent',
      }
    ]

    const report_wrapper = ref(null)

    /// here use root form as dialy report setting

    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }
    const saveDialySetting = (reportName) => {
      let setting_data = request.value;
      delete setting_data.to;
      delete setting_data.from;

      ReportSetting.setSettings(reportName, setting_data).then((res) => {
        toaster(root.$root.$t('settigs saved succeffly!!'), 'scuccess', root.$root.$t('success!!'))
      })

        .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    }
    onMounted(() => {
      if (props.report_type == "setting") {
        ReportSetting.getSetting('containerPestPlanSummary').then((res) => {
          request.value = res;
        })
      }
    })

    const refilterContractByOwner = (owners_ids) => {
      let result = contracts_orig.value.filter((i) => owners_ids.includes(i.contractor_id));
      contracts.value = JSON.parse(JSON.stringify(result));  

      if (owners_ids.length == 0) { contracts.value = JSON.parse(JSON.stringify(contracts_orig.value)) }
    }

    //here end of   dialy report setting
    return {
      report_data, 
      report_fields, 
      filter_included_fields, 
      total, 
      from,
      to,
      tableRef,
      getReport,
      pickerOptions,
      report_wrapper,
      request,
      loading,
      errors,
      owners, 
      contracts, 
      refilterContractByOwner,
      reportLogic,
      saveDialySetting,
      sortData,
      dataTableloading
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';


.group-row {
  background-color: #ddd;
}
</style>
